import clockSvg from 'assets/icons/clock.svg';
import Chip from 'lib/Chip';
import { Size } from 'lib/Chip/Chip.types';
import { handleReportCreationDateTime } from './util';

interface ReportCreationDateChipProps {
  creationDateTime: string;
}

export const ReportCreationDateChip: React.FC<ReportCreationDateChipProps> = ({ creationDateTime }) => {
  const chipLabel = handleReportCreationDateTime(creationDateTime);

  return (
    <div className="ml-2">
      <Chip icon={clockSvg} label={chipLabel} size={Size.SMALL} />
    </div>
  );
};
